module.exports = __webpack_public_path__ + "img/img_diaocha.b434ad31.jpg";